module.exports = __webpack_public_path__ + "static/img/oxblue.a2154a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/oxblue.png
// module id = 90sZ
// module chunks = 7